import { createSlice } from '@reduxjs/toolkit';

export const profileSlice = createSlice({
    name: 'userProfile',
    initialState: {
        file: null,
        profileData: {},
    },
    reducers: {
        addProfile: (state, action) => {
            state.file = action.payload;
        },
        addProfileData: (state, action) => {
            state.profileData = action.payload;
        },
    }
})

export const { addProfile , addProfileData } = profileSlice.actions;
export default profileSlice.reducer;